module.exports = __webpack_public_path__ + "static/media/semantic-banner.d1c0fdc7.png";